import { z } from 'zod';

const resetPasswordStateSchema = z.object({
  email: z.string().optional(),
  code: z.string().optional(),
});

/**
 * The reset steps pass the email (and later the code) to the next step as router state, which is
 * untyped and missing when a step is opened directly. Missing values become empty strings, which
 * the endpoint rejects like any other invalid input.
 */
export const readResetPasswordState = (state: unknown) => {
  const parsed = resetPasswordStateSchema.safeParse(state).data;

  return { email: parsed?.email ?? '', code: parsed?.code ?? '' };
};
